export const updateProfileErrorInformation: { [id: string]: string } = {
  "takeda authorization failed":
    "Acces token invalid or expired. Please log again.",
};
